import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { LazyLoadedTableDataSource } from 'src/app/shared/components/mat-table/lazy-loaded.data-source';
import { TriggeredTableDataSource } from 'src/app/shared/components/mat-table/triggered.data-source';

@Component({
  selector: 'shared-table-empty-data',
  templateUrl: './table-empty-data.component.html',
  styleUrl: './table-empty-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableEmptyDataComponent {
  @Input() dataSource: LazyLoadedTableDataSource<any> | TriggeredTableDataSource<any> | MatTableDataSource<any>;

  get isTriggeredDataSource(): boolean {
    return this.dataSource instanceof TriggeredTableDataSource;
  }

  get triggeredDataSource(): TriggeredTableDataSource<any> | null {
    return this.isTriggeredDataSource ? (this.dataSource as TriggeredTableDataSource<any>) : null;
  }

  get isEmpty(): boolean {
    return this.dataSource?.data?.length === 0;
  }

  get lazyLoadedDataSource(): LazyLoadedTableDataSource<any> | null {
    return this.dataSource instanceof LazyLoadedTableDataSource ? this.dataSource : null;
  }

  get maxLoopCountExceeded$(): Observable<boolean> | null {
    return this.lazyLoadedDataSource?.maxLoopCountExceeded$ ?? null;
  }
}
